import Scoreboard from './scoreboard';
export default Scoreboard;


// WEBPACK FOOTER //
// ./containers/Scoreboard/index.js